 function tooglerInit(){
    $('[data-toggle]').on('click',e=>{
        let toggler = e.currentTarget.dataset.toggle;
        $(toggler).toggleClass('active')
    })
    
    $('[data-slide-toggle]').on('click',e=>{
        let toggler = e.currentTarget.dataset.slideToggle;
        console.log(toggler)
        $(toggler).slideToggle();
    })
}
function popUpShow(popup){
    let $pAcative = $('.popup.active');
    let $popup = $(popup);
    if($pAcative !==  $popup ){
        $pAcative.removeClass('active')
    }
    $popup.addClass('active')
    $('body').addClass('popupShow')
    $('.popup-shape').addClass('active')
}
function popUpHide(popup){
    if(popup){
        $(popup).removeClass('active') 
    }
    else{
        $('.popup').removeClass('active')     
    }
    $('body').removeClass('popupShow')
    $('.popup-shape').removeClass('active')
}
function popUpSwitch(popup){
    $('.popup').removeClass('active')
    $(popup).addClass('active') 
}
function runSlickSlider(){
    
    if($ && $.fn.slick){
        $('.categories-slider').slick({
            dots: false, 
            slidesToShow: 10,
            arrows:false,
            swipeToSlide:true,
            responsive: [
                {
                    breakpoint: 1400,
                    settings: {
                        slidesToShow: 8
                    }
                }, {
                    breakpoint: 1024,
                    settings: {
                        slidesToShow: 7
                    }
                }, {
                    breakpoint: 768,
                    settings: {
                        slidesToShow: 5
                    }
                },{
                    breakpoint: 576,
                    settings: {
                        slidesToShow: 4
                    }
                },{  
                    breakpoint: 400,
                    settings: {
                        slidesToShow: 3
                    }
                },{  
                    breakpoint: 350,
                    settings: {
                        slidesToShow: 2
                    }
                },
                
            ]
        });
        
        $('.seriveces-slider').slick({
            dots: false, 
            arrows:true,
            slidesToShow: 3, 
            infinite: false,
            swipeToSlide:true,
            
            prevArrow:$('.seriveces-slider-button--prev'),
            nextArrow:$('.seriveces-slider-button--next'),
            
            responsive: [
                {
                    breakpoint: 1300,
                    settings: {
                        slidesToShow: 2
                    }
                },  {
                    breakpoint: 768,
                    settings: {
                        slidesToShow: 1
                    }
                }, 
            ]
        });
    }
}
function footerSubmit(form){
    let serialize = $(form).serialize()
    console.log('footerSubmit',{serialize});
    return false
}

let isscrollbizzy = false
function mainScroll(){
    
    let isMainPage = document.querySelector('.js-isMainPage');
    if(!isMainPage) return
    
    document.addEventListener('wheel', function(e) {
        if(isscrollbizzy){
            e.preventDefault();
            return
        }
        let scroll = $('html, body').scrollTop()
        let top = null;
        if(e.deltaY > 0) { 
            $('.js-scrollTo').each((i,_elem)=>{
                if(scroll<$(_elem).offset().top){
                e.preventDefault();
                isscrollbizzy = true
                    top = $(_elem).offset().top
                    return
                }
            })
        } else { 
            $('.js-scrollTo').each((i,_elem)=>{
                if(scroll>$(_elem).offset().top){
                e.preventDefault();
                isscrollbizzy = true
                    top = $(_elem).offset().top
                    return
                }
            })
        }
        if(top!==null){
            $('html, body').animate({
                scrollTop: top
            }, 1000,()=>{  
                isscrollbizzy = false;
            });
        }
    }, { passive: false });
    
}
function headerPadding(){
    $('.display-height,.header-ref').css({
        paddingTop:$('header')[0].offsetHeight
    })
}
function changeDisabled(form,isdisabled)
{
    let disabledElementList = form.querySelectorAll('[disabled],.btn-submit,[type="submit"]')
    if(!disabledElementList) return
    disabledElementList.forEach(disabledElement=>{ disabledElement.disabled = isdisabled  })
}
function formValidate(inputRequiredList) {  
    let isFormValidate = true
    inputRequiredList.forEach(input=>{
        let addCheck = true
        if(input.name=='phone'){
            addCheck = phoneValidate(input)
        }
        let isInputValidate =  addCheck && input.value.length
        if(!isInputValidate){
            input.classList.add('input-error')
        }
        else{
            input.classList.remove('input-error')
        } 
        if(input.dataset.counterValidate){
            isInputValidate = isInputValidate && countetrValidate(input);
        }
        isFormValidate = isFormValidate  && isInputValidate
    }) 
    return isFormValidate
}
function countetrValidate(input) {
    let orValue = document.querySelector('[name="rooms"]').value
    if(input.value == 0  && orValue == 0){
        input.classList.add('input-error');
        return false
    }
    else{
        return trueu
    }
}
function phoneValidate(input){
    let regExp = new RegExp(/^\+?3?8?(0\d{9})$/im)
    return regExp.test(input.value)
}
function checkSubmitDisable(){
    $('form').each((i,form)=>{
        let inputRequiredList =form.querySelectorAll('input[required]')
        if(!inputRequiredList){
            changeDisabled(form,false);
            return
        }
        inputRequiredList.forEach(input=>{ 
            input.addEventListener('keyup',()=>{ 
                if(formValidate(inputRequiredList)){
                    changeDisabled(form,false);
                } else{
                    changeDisabled(form,true);
                }
            })
        })
    })
}
function initTabs() {
    $('[data-tab-switcher]').on('click',(event)=>{
        let elem = event.currentTarget
        let index = elem.dataset.tabSwitcher
        let $parent =$(elem).parents('.js-tab-container');
        let $target = $parent.find('[data-tab-content="'+ index +'"]')

        if(!$parent[0]) {
            console.error('doesn\'t find tab parent')
            return
        }
        if(!$target[0]) {
            console.error('doesn\'t find tab target')
            return
        }
        if($target[0]){
            $parent.find('[data-tab-content],[data-tab-switcher]').removeClass('active')
            $(elem).addClass('active')
            $target.addClass('active')
        }
    })
} 
function checkboxFormValidate() {
    let $form = $('.js-checkbox-form')
    $form.find('input').on('change',()=>{
        $form.find('.btn-submit')[0].disabled = !findChecked();
    })
    
    function findChecked() {
        // вернет true если есть чекнутый инпут 
        let _inputList = $form[0].querySelectorAll('input')
        
        return Array.from(_inputList).some(input=>{
            return input.checked
        })
    }
}
function preloadRemove() {
    $('.preload').remove();
}
function stickyHeader(direction){
    if(direction){
        $('header').addClass('fixed')
        if(direction >0 ){
            //console.log('header hide')
            $('header').removeClass('show')
        }
        if(direction <0 ){
            //console.log('header show')
            $('header').addClass('show')
            $('header').addClass('trans')
        }
    }
}
function unStickyHeader(){
    $('header').removeClass('fixed').removeClass('show').removeClass('trans')
}
function firstLoad(){
    setTimeout(() => {
        if(!lastScrollTop && !scrollDirty){
            smoothScrollTo($('.js-scrollTo'))
        }
    }, 5000);
}
function smoothScrollTo($elem){
    $('html, body').animate({
        scrollTop: $elem.offset().top
    }, 100,()=>{saveState()});
    
}
function saveState(){
    localStorage.setItem('isVisited', true);
}
function scrollTop(){
    $('html, body').animate({
        scrollTop:0
    }, 100);
}
function mload(){
    if( /Android|webOS|iPhone|iPad|iPod|BlackBerry/i.test(navigator.userAgent) ) {
        $('body').addClass('ios');
    };
    
    let $canvas = $('.main_decor canvas');
    $canvas.each((i,convas)=>{
        // bubls(convas);
        bubls2(convas);
    })
    lastScrollTop = window.pageYOffset || document.documentElement.scrollTop;

    $('.counter').counter();
    
    checkSubmitDisable() 
    runSlickSlider()
    tooglerInit() // init data-toggle click
    mresize()
    
    // mainScroll()
    const isMainPage = $('.js-isMainPage')[0]
    const isVisited = localStorage.getItem('isVisited');
    if(isMainPage && isVisited){
        smoothScrollTo($('.js-scrollTo'))
    }
    if(isMainPage && !isVisited){
        firstLoad();
    }
    $('.mouse_scroll').on('click',()=>{
        smoothScrollTo($('.js-scrollTo'))
    })
    $('.upBtn button').on('click',()=>{
        scrollTop()
    })
    initTabs();
    
    checkboxFormValidate()
    
    preloadRemove()
    mscroll();
    
}
function mresize(){
    // decor()
    headerPadding()
    
}

let lastScrollTop = 0; 
let scrollDirty = false
function mscroll(e){ 
    let scrollDirection = 0;
    if(e){
        scrollDirty = true;
        saveState()
    }
    let st = window.pageYOffset || document.documentElement.scrollTop;
    if (st > lastScrollTop){
        // downscroll code
        scrollDirection = 1
    } else {
        // upscroll code
        scrollDirection = -1
    }
    lastScrollTop = st <= 0 ? 0 : st; // For Mobile or negative scrolling
    const headerheight = $('header')[0].offsetHeight
    
    if(lastScrollTop > headerheight){
        stickyHeader(scrollDirection)
        $('.upBtn').addClass('show')
    } else {
        $('.upBtn').removeClass('show')
    }
    if (lastScrollTop == 0 ){
        unStickyHeader()
    }
    
    


}



$(window).on('load', mload);
$(window).on('resize', mresize);
$(window).on('scroll', mscroll);



$.prototype.counter = function () {
    if(!this[0]) return  
    if(this.length){
        this.each((i,e)=>{ 
            init(e)
        })
    }
    else{
        init(this)
    }
    function init(item) {
        
        let input = item.querySelector('.counter-input');
        let btns = item.querySelectorAll('.counter-btn');
        btns.forEach(btn=>{
            btn.addEventListener('click',e=>onBtnClick(btn,e))
        })
        
        inputUpdate();
        input.addEventListener('change',()=>inputUpdate())
        // input.addEventListener('keydown',()=>inputUpdate())
        input.addEventListener('keyup',()=>inputUpdate())
        input.addEventListener('focus',()=>inputUpdate())
        
        function inputUpdate() {
            let value = parseInt(input.value)
            let minus = item.querySelector('.js-counter-minus')
            
            input.value = value>0? value : 0
            if(!minus) return
            minus.disabled =  !+input.value
            
        }
        function onBtnClick(btn,e) {
            e.preventDefault();
            let val = input.value;
            let isMinus = !!btn.classList.contains('js-counter-minus')
            if(isMinus){
                input.value =+(input.value) -1
            }
            else{
                input.value =+(input.value) +1
            }
            inputUpdate();           
        }
    }
}


function bubls( item ) { 
    console.log({item})
    var node = {
        x: 0,
        y: 0,
        vx: 0,
        vy: 0,
        radius: 2,
        shadowColor: 0,
        shadowBlur: 0,
        globalAlpha: 0,
        
        create: function(x, y, speed, direction) {
            var obj = Object.create(this);
            obj.x = x;
            obj.y = y;
            obj.vx = Math.cos(direction) * speed;
            obj.vy = Math.sin(direction) * speed;
            return obj;
        },
        
        getSpeed: function() {
            return Math.sqrt(this.vx * this.vx + this.vy * this.vy);
        },
        
        setSpeed: function(speed) {
            var heading = this.getHeading();
            this.vx = Math.cos(heading) * speed;
            this.vy = Math.sin(heading) * speed;
        },
        
        getHeading: function() {
            return Math.atan2(this.vy, this.vx);
        },
        
        setHeading: function(heading) {
            var speed = this.getSpeed();
            this.vx = Math.cos(heading) * speed;
            this.vy = Math.sin(heading) * speed;
        },
        
        update: function() {
            this.x += this.vx;
            this.y += this.vy;
        }
    };
    
    var canvas = item,
    ctx = canvas.getContext('2d'),
    colors = ['#33333'],
    width = canvas.width = window.innerWidth,
    height = canvas.height = window.innerHeight,
    bubbles = [],
    bubblesSum = 10,
    layers = [
        { speed: 0.75 },
        { speed: .82 },
        { speed: 0.6 }
    ],
    bubblesAngle = -90;
    
    function randomRange(min, max) {
        return parseInt(min + Math.random() * (max - min), 10);
    }
    
    function degreesToRads(degrees) {
        return degrees / 180 * Math.PI;
    }
    
    for (var j = 0; j < layers.length; j += 1) {
        var layer = layers[j];
        for (var i = 0; i < bubblesSum; i += 1) {
            var bubble = node.create(randomRange(0, width), randomRange(0, height), 0, 0);
            bubble.setSpeed(layer.speed);
            bubble.radius = randomRange(8, 64);
            bubble.setHeading(degreesToRads(bubblesAngle));
            bubble.shadowColor = colors[parseInt(Math.random()*(7-0)+0, 10)];
            bubble.globalAlpha = (Math.floor(Math.random()*10))/10;
            bubbles.push(bubble);
        }
    }
    
    var breeze = 0;
    
    function makeBubble(bubble) {
        ctx.globalAlpha = bubble.globalAlpha;
        ctx.shadowBlur = bubble.shadowBlur;
        ctx.shadowColor = bubble.shadowColor;
        ctx.beginPath();
        ctx.arc(bubble.x, bubble.y, ( bubble.radius + Math.sin( breeze / 60 ) * 2), 0, Math.PI * 2, false);
        ctx.strokeStyle = "#2DB8D4";
        ctx.lineWidth = 3;
        ctx.stroke();
    }
    
    function update() {
        ctx.clearRect(0, 0, width, height);
        
        for (var i = 0; i < bubbles.length; i += 1) {
            var b = bubbles[i];
            b.update();
            makeBubble(b);
            if (b.y < -100) {
                b.y = height;
            }
        }
        breeze++;
        requestAnimationFrame(update);
    }
    
    update(); 
}

function bubls2(elem) {
    // ---------
    // Functions
    // ---------
    
    var canvas = elem //document.querySelector('canvas');
    canvas.width = window.innerWidth; // document.body.clientWidth;
    canvas.height = window.innerHeight; // document.body.clientHeight;
    var ctx = canvas.getContext('2d');
    var count = canvas.height;
    var bubbles = [];
    var bubbleCount = 50;
    var bubbleSpeed = 1;
    var popLines = 6;
    var popDistance = 40;
    var mouseOffset = {
        x: 0,
        y: 0
    }
    
    
    
    // --------------
    // Animation Loop
    // --------------
    
    function animate() {
        
        
        
        // ------------
        // Clear Canvas
        // ------------
        
        ctx.clearRect(0, 0, canvas.width, canvas.height);
        
        
        
        // ------------
        // Draw Bubbles
        // ------------
        
        ctx.beginPath();
        for (var i = 0; i < bubbles.length; i++) {
            // first num = distance between waves
            // second num = wave height
            // third num = move the center of the wave away from the edge
            
            bubbles[i].position.x = Math.sin(bubbles[i].count/bubbles[i].distanceBetweenWaves) * 50 + bubbles[i].xOff;
            bubbles[i].position.y = bubbles[i].count;
            bubbles[i].render();
            
            if(bubbles[i].count < 0 - bubbles[i].radius) {
                bubbles[i].count = canvas.height + bubbles[i].yOff;
            } else {
                bubbles[i].count -= bubbleSpeed;
            }
        }
        
        // ---------------
        // On Bubble Hover
        // ---------------
        
        for (var i = 0; i < bubbles.length; i++) {
            if(mouseOffset.x > bubbles[i].position.x - bubbles[i].radius && mouseOffset.x < bubbles[i].position.x + bubbles[i].radius) {
                if(mouseOffset.y > bubbles[i].position.y - bubbles[i].radius && mouseOffset.y < bubbles[i].position.y + bubbles[i].radius) {
                    for (var a = 0; a < bubbles[i].lines.length; a++) {
                        popDistance = bubbles[i].radius * 0.5;
                        bubbles[i].lines[a].popping = true;
                        bubbles[i].popping = true;
                    }
                }
            }
        }
        
        window.requestAnimationFrame(animate);
    }
    
    window.requestAnimationFrame(animate);
    
    
    
    // ------------------
    // Bubble Constructor
    // ------------------
    
    var createBubble = function() {
        
        this.position = {x: 0, y: 0};
        this.radius = 8 + Math.random() * 6;
        this.xOff = Math.random() * canvas.width - this.radius;
        this.yOff = Math.random() * canvas.height;
        this.distanceBetweenWaves = 50 + Math.random() * 40;
        this.count = canvas.height + this.yOff;
        this.color = '#000';
        this.lines = [];
        this.popping = false;
        this.maxRotation = 85;
        this.rotation = Math.floor(Math.random() * (this.maxRotation - (this.maxRotation * -1))) + (this.maxRotation * -1);
        this.rotationDirection = 'forward';
        
        // Populate Lines
        for (var i = 0; i < popLines; i++) {
            var tempLine = new createLine();
            tempLine.bubble = this;
            tempLine.index = i;
            
            this.lines.push(tempLine);
        }
        
        this.resetPosition = function() {
            this.position = {x: 0, y: 0};
            this.radius = 8 + Math.random() * 6;
            this.xOff = Math.random() * canvas.width - this.radius;
            this.yOff = Math.random() * canvas.height;
            this.distanceBetweenWaves = 50 + Math.random() * 40;
            this.count = canvas.height + this.yOff;
            this.popping = false;
        }
        
        // Render the circles
        this.render = function() {
            if(this.rotationDirection === 'forward') {
                if(this.rotation < this.maxRotation) {
                    this.rotation++;
                } else {
                    this.rotationDirection = 'backward';
                }
            } else {
                if(this.rotation > this.maxRotation * -1) {
                    this.rotation--;
                } else {
                    this.rotationDirection = 'forward';
                }
            }
            
            ctx.save();
            ctx.translate(this.position.x, this.position.y);
            ctx.rotate(this.rotation*Math.PI/180);
            
            if(!this.popping) {
                ctx.beginPath();
                ctx.strokeStyle = '#8bc9ee';
                ctx.lineWidth = 1;
                ctx.arc(0, 0, this.radius - 3, 0, Math.PI*1.5, true);
                ctx.stroke();
                
                ctx.beginPath();
                ctx.arc(0, 0, this.radius, 0, Math.PI*2, false);
                ctx.stroke();
            }
            
            ctx.restore();
            
            // Draw the lines
            for (var a = 0; a < this.lines.length; a++) {
                if(this.lines[a].popping) {
                    if(this.lines[a].lineLength < popDistance && !this.lines[a].inversePop) {
                        this.lines[a].popDistance += 0.06;
                    } else {
                        if(this.lines[a].popDistance >= 0) {
                            this.lines[a].inversePop = true;
                            this.lines[a].popDistanceReturn += 1;
                            this.lines[a].popDistance -= 0.03;
                        } else {
                            this.lines[a].resetValues();
                            this.resetPosition();
                        }
                    }
                    
                    this.lines[a].updateValues();
                    this.lines[a].render();
                }
            }
        }
    }
    
    
    
    // ----------------
    // Populate Bubbles
    // ----------------
    
    for (var i = 0; i < bubbleCount; i++) {
        var tempBubble = new createBubble();
        bubbles.push(tempBubble); 
    }
    
    
    
    // ----------------
    // Line Constructor
    // ----------------
    
    function createLine() {
        this.lineLength = 0;
        this.popDistance = 0;
        this.popDistanceReturn = 0;
        this.inversePop = false; // When the lines reach full length they need to shrink into the end position
        this.popping = false;
        
        this.resetValues = function() {
            this.lineLength = 0;
            this.popDistance = 0;
            this.popDistanceReturn = 0;
            this.inversePop = false;
            this.popping = false;
            
            this.updateValues();
        }
        
        this.updateValues = function() {
            this.x = this.bubble.position.x + (this.bubble.radius + this.popDistanceReturn) * Math.cos(2 * Math.PI * this.index / this.bubble.lines.length);
            this.y = this.bubble.position.y + (this.bubble.radius + this.popDistanceReturn) * Math.sin(2 * Math.PI * this.index / this.bubble.lines.length);
            this.lineLength = this.bubble.radius * this.popDistance;
            this.endX = this.lineLength;
            this.endY = this.lineLength;
        }
        
        this.render = function() {
            this.updateValues();
            
            ctx.beginPath();
            ctx.strokeStyle = '#8bc9ee';
            ctx.lineWidth = 2;
            ctx.moveTo(this.x, this.y);
            if(this.x < this.bubble.position.x) {
                this.endX = this.lineLength * -1;
            }
            if(this.y < this.bubble.position.y) {
                this.endY = this.lineLength * -1;
            }
            if(this.y === this.bubble.position.y) {
                this.endY = 0;
            }
            if(this.x === this.bubble.position.x) {
                this.endX = 0;
            }
            ctx.lineTo(this.x + this.endX, this.y + this.endY);
            ctx.stroke();
        };
    }
    
    
    
    // ---------------
    // Event Listeners
    // ---------------
    
    window.addEventListener('mousemove', mouseMove);
    
    function mouseMove(e) {
        mouseOffset.x = e.offsetX;
        mouseOffset.y = e.offsetY - $(window).scrollTop();
    }
    
    window.addEventListener('resize', function() {
        canvas.width =window.innerWidth // document.body.clientWidth;
        canvas.height = window.innerHeight //document.body.clientHeight;
    });
    
    
    // ---------------
    // Event Listeners
    // ---------------
}